import type {IAsset} from '@netx/core-asset-next/schema';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	assetPermissionChecker,
	PermissionMatrixName,
	PermissionName,
} from '@netx/core-permissions-next/utils/assetPermissionChecker';
import {assetHasConstituentClips} from '@netx/core-asset-next/enablers';

export const canViewAssetConstituentClips = (asset?: IAsset): boolean => {
	if (!assetHasConstituentClips(asset)) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.READ,
		permissionName: PermissionName.VIEW,
	});
};
